import { DataBox } from './DataBox'
import { PageHeader } from './PageHeader'

export function Pending() {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}
